import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Flex } from 'reflexbox'
import { Tab } from 'react-toolbox/lib/tabs'
import Collapse from 'components/fulcrum/collapse/Collapse'

import Tabs from 'containers/ProjectCreatePage/Tabs'
import TabContentHoc from 'containers/ProjectCreatePage/TabContent'
import RefreshFilterButton from 'containers/ProjectCreatePage/RefreshFilterButton'
import CollapseIconButton from 'containers/ProjectCreatePage/CollapseIconButton'
import CollapseButton from 'containers/ProjectCreatePage/CollapseButton'
import Card from 'containers/ProjectCreatePage/Card'
import Divider from 'components/fulcrum/divider/Divider'
import Layout from 'containers/ProjectCreatePage/Layout'
import Header from 'containers/ProjectCreatePage/Header'
import ProductTabs from 'containers/ProjectCreatePage/ProductHierarchyTabs'
import Actionbar from 'containers/ProjectCreatePage/Actionbar'
import {
  initializeData,
  resetProductHierarchyFilter,
  toggleProductHierarchyCollapse,
  clearInitialData,
} from 'containers/ProjectCreatePage/actions'
import {
  disabledButtonSelector,
} from 'containers/ProjectCreatePage/selectors'

import styles from 'containers/ProjectCreatePage/styles.scss'

const mapStateToProps = (state) => {
  return {
    isProductHierarchyCollapse: state.uiState.projectCreate.productHierarchy.isCollapse,
    disabledButton: disabledButtonSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleProductHierarchyCollapse: () => dispatch(toggleProductHierarchyCollapse()),
    initializeData: () => dispatch(initializeData()),
    resetProductHierarchies: () => dispatch(resetProductHierarchyFilter()),
    clearInitialData: () => dispatch(clearInitialData()),
  }
}

class ProductPage extends Component {
  componentWillMount() {
    this.props.clearInitialData()
  }

  componentDidMount() {
    this.props.initializeData()
  }

  render() {
    const {
      toggleProductHierarchyCollapse,
      isProductHierarchyCollapse,
      resetProductHierarchies,
      disabledButton,
    } = this.props

    return (
      <Layout>
        <Card>
          <Header label='Select Hierarchy'>
            <RefreshFilterButton
              onClick={resetProductHierarchies}
            />
            <CollapseIconButton
              collapse={isProductHierarchyCollapse}
              onClick={toggleProductHierarchyCollapse}
            />
          </Header>
          <Divider/>
          <ProductTabs/>
        </Card>
        <Actionbar
          disabled={disabledButton}
          to='/product/overview'
        />
      </Layout>
    )
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyles = CSSModules(styles)
const enhance = compose(
  withConnect,
  withStyles
)

export default enhance(ProductPage)
